// extracted by mini-css-extract-plugin
export default {"header":"header__DTK6R","wrapper":"wrapper__e6Gnw","brand":"brand__LTrVA","navigation":"navigation__GTrWA"};